import angular from 'angular';
import booksDom from './booksDom';
import booksService from './booksServices';
import CSMBooksWeb from '../CSMBooksWeb';
import CSMCommonWeb from 'csm-common-web';
import { vendorsServiceProvider } from './services/VendorsService';
import './books.css';

export default angular
  .module('csm.books', [
    booksDom,
    booksService,
    CSMBooksWeb,
    CSMCommonWeb
  ])
  .constant('BooksEvents', {
    LOGO_CHANGED: 'logo-changed'
  })
  .provider('VendorsService', vendorsServiceProvider)
  .name;
